const detectMimeType = (base64) => {
  if (base64.startsWith('JVBER')) return 'application/pdf';
  if (base64.startsWith('iVBOR')) return 'image/png';
  if (base64.startsWith('/9j/')) return 'image/jpeg';
  throw new Error('Formato de arquivo não suportado');
};

const getExtensionByMime = (mime) => {
  if (mime === 'application/pdf') return '.pdf';
  if (mime === 'image/png') return '.png';
  if (mime === 'image/jpeg') return '.jpg';
  return '';
};

export const base64ToImage = (b64Data) => {
  const cleanBase64 = b64Data.replace(/^"+|"+$/g, '');

  const mimeType = detectMimeType(cleanBase64);
  const extension = getExtensionByMime(mimeType);

  const byteCharacters = atob(cleanBase64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);

    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    byteArrays.push(new Uint8Array(byteNumbers));
  }

  return {
    blob: new Blob(byteArrays, { type: mimeType }),
    mimeType,
    extension,
  };
}